module.exports = __webpack_public_path__ + "static/img/zhuce_ic_qiye@2x.cb6d4309.png";